import { useCallback } from 'react';
import { ord, string } from 'fp-ts';
import { BusinessSegment, BusinessSegmentResult } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { useEnterpriseBusinessSegmentsQuery } from '@mews-commander/core/entities';

const ordBusinessSegment = ord.contramap((businessSegment: BusinessSegment) => businessSegment.name)(string.Ord);
export const useBusinessSegmentOptions = (serviceId: string) => {
    const { data: businessSegmentOptions = [] } = useEnterpriseBusinessSegmentsQuery(
        useCallback(
            (data: BusinessSegmentResult) =>
                data?.businessSegments
                    ?.filter((segment) => segment.serviceId === serviceId)
                    .toSorted(ordBusinessSegment.compare)
                    .map(({ id, name }) => createOption({ value: id, label: name })),
            [serviceId]
        )
    );

    return businessSegmentOptions;
};
